import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { Element } from "../../models/base-info/element.model";
import { EffectStatuteKind } from "../../models/enums/effect-statute-kind";
import { ElementGroup } from "../../models/enums/element-group";
import { FinanceNotificationDetail, FinanceNotificationHeader } from "../../models/finance-notification-header.model";

@Component({
  selector: "ngx-finance-notification-header-form",
  templateUrl: "./finance-notification-header-form.component.html",
  styleUrls: ["./finance-notification-header-form.component.scss"],
})
export class FinanceNotificationHeaderFormComponent extends BaseFormComponent<FinanceNotificationHeader> {
  public apiName: string = "FinanceNotificationHeader";
  public label: string = "حکم مالی";
  activeTabTitle: string = "کسور";
  EmploymentKindId: number = 0;
  DeductColumns: FinanceNotificationDetail[];
  BossColumns: FinanceNotificationDetail[];
  WorkColumns: FinanceNotificationDetail[];
  OtherColumns: FinanceNotificationDetail[];
  ActiveElement: Element[];
  FinanceNotificationDetails: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DeductColumns = undefined;
    this.BossColumns = undefined;
    this.WorkColumns = undefined;
    this.OtherColumns = undefined;
    this.ActiveElement = undefined;
    this.FinanceNotificationDetails = undefined;
  }
  async ngOnInit() {
    if (this.currentrow) this.EmploymentKindId = this.currentrow.EmploymentKindId;
    super.ngOnInit();
    this.apiName = "FinanceNotificationHeader";
    this.label = "حکم مالی";
    super.ngOnInit();
    this.isNewRow = this.currentrow.State === RowState.New;
  }
  setdefault(): void {
    this.isNewRow = this.currentrow.State === RowState.New;
    if (this.isNewRow && !this.model.HrmPersonnelId && this.currentrow) Object.assign(this.model, this.currentrow);
    if (!this.model.IsGroupedIssue) {
      this.model.IsGroupedIssue = false;
    }
    if (this.isNewRow) {
      this.model.Id = 0;
      if (this.model.FinanceNotificationDetails) {
        this.model.FinanceNotificationDetails.forEach((x) => {
          x.Id = 0;
          x.FinanceNotificationHeaderId = 0;
        });
      }
    }
    if (this.model) this.populateElement();
  }
  populateElement() {
    this.httpCommonService
      .getList("FinanceNotificationHeader/GetActiveElement/" + this.EmploymentKindId + "/" + this.model.HrmPersonnelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Element[]) => {
          if (data) {
            this.ActiveElement = data as [];
            if (!this.model.FinanceNotificationDetails) this.model.FinanceNotificationDetails = [];
            data.forEach((element) => {
              if (!this.model.FinanceNotificationDetails.some((e) => e.ElementId === element.Id)) {
                this.model.FinanceNotificationDetails.push({
                  ElementId: element.Id,
                  ElementTitle: element.Title,
                  State: RowState.New,
                  FinanceNotificationHeaderId: this.model.Id,
                  Id: 0,
                  EffectDate: new Date(),
                  ElementGroupId: element.ElementGroupId,
                  ElementGroupTitle: element.ElementGroupTitle,
                  ElementGroupCode: element.ElementGroupCode,
                  Amount: 0,
                  MonthAmount: 0,
                  DayAmount: 0,
                  HourAmount: 0,
                });
              }
            });
            this.DeductColumns = this.model.FinanceNotificationDetails.filter((x) => x.ElementGroupCode === ElementGroup.Deduct) as [];
            this.BossColumns = this.model.FinanceNotificationDetails.filter((x) => x.ElementGroupCode === ElementGroup.Boss) as [];
            this.WorkColumns = this.model.FinanceNotificationDetails.filter((x) => x.ElementGroupCode === ElementGroup.Work) as [];
            this.OtherColumns = this.model.FinanceNotificationDetails.filter((x) => x.ElementGroupCode === ElementGroup.Other) as [];
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.FinanceNotificationDetails = this.getDetailControlModels("FinanceNotificationDetails");
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  beforupdate() {
    this.model.FinanceNotificationDetails = [...this.DeductColumns, ...this.BossColumns, ...this.WorkColumns, ...this.OtherColumns];
    this.model.FinanceNotificationDetails.forEach((x) => {
      if (x.Amount) {
        let elmnt = this.ActiveElement.find((f) => f.Id === x.ElementId);
        elmnt.ElementPropertys = elmnt.ElementPropertys.sort((a, b) => b.Id - a.Id);

        if (elmnt && elmnt.ElementPropertys[0].EffectStatuteKindCode === EffectStatuteKind.Monthly) x.MonthAmount = x.Amount;
        if (elmnt && elmnt.ElementPropertys[0].EffectStatuteKindCode === EffectStatuteKind.Daily) x.DayAmount = x.Amount;
        if (elmnt && elmnt.ElementPropertys[0].EffectStatuteKindCode === EffectStatuteKind.Hourly) x.HourAmount = x.Amount;
      }
    });
  }
}
